<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <!-- <search id="header-search" class="right-menu-item" />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>

        <lang-select class="right-menu-item hover-effect" /> -->

      </template>

      <!--      <i class="el-icon-setting setting-icon" @click.stop="toggleRightPanel"></i>-->
      <svg-icon icon-class="diy-Setting" class="setting-icon" @click.stop="toggleRightPanel" />
      <div class="divider" />
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <div style="display:flex;align-items:center;justify-content:left;">
            <el-avatar :size="30" :src="logo" style="border-radius: 5px" />
            <span>{{ userIfon.realName }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/profile/index">
            <el-dropdown-item>
              {{ $t('navbar.profile') }}
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="clearCache">
            {{ $t('清空缓存') }}
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">{{ $t('navbar.logOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import LangSelect from '@/components/LangSelect'
// import Search from '@/components/HeaderSearch'
import { clearCache } from '@/api/system'
import { getInfo } from '@/api/user'
import { closeWebsocket } from '../../utils/webSocket'
export default {
  components: {
    Breadcrumb,
    Hamburger
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    // LangSelect,
    // Search
  },
  data() {
    return {
      userIfon: {},
      logo: require('@/assets/larke/larke.a37c4b81.png')
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ])
  },
  created() {
    getInfo().then((data) => {
      this.userIfon = data.data
    })
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    clearCache() {
      const thiz = this
      clearCache().then((res) => {
        if (res.code === 0) {
          this.$message({
            message: thiz.$t('清空网站缓存成功'),
            type: 'success',
            duration: 3 * 1000
          })
        }
      })
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      closeWebsocket()
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      window.location.reload()
    },
    toggleRightPanel() {
      console.log(123123123)
      this.$emit('toggle-right-panel')
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden; /* 确保内容不会溢出 */
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  display: flex; /* 使用 flex 布局 */
  align-items: center; /* 垂直居中 */
  justify-content: space-between; /* 左右分布 */

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;
    padding: 0 15px; /* 添加一些内边距 */

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    flex: 1; /* 占据剩余空间 */
  }

  .right-menu {
    height: 100%;
    display: flex;
    align-items: center; /* 垂直居中 */
    padding-right: 24px; /* 添加一些右边距 */

    .right-menu-item {
      padding: 0;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      display: flex;
      align-items: center; /* 垂直居中 */

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        display: flex;
        align-items: center; /* 垂直居中 */
        height: 100%;
        padding: 0; /* 添加内边距 */
        box-sizing: border-box; /* 确保边框不增加元素尺寸 */

        .el-avatar {
          //box-shadow: 0px 2px 2px #ccc;
        }

        span {
          font-size: 14px;
          color: #000;
        }

        .el-icon-caret-bottom {
          margin-left: 5px;
          font-size: 12px;
        }
      }
    }
  }
  .setting-icon {
    font-size: 18px; /* 调整自己需要的大小，比如 22px 或 24px */
    cursor: pointer; /* 鼠标悬停变小手 */
  }
  .divider {
    width: 1px;
    height: 20px;
    background-color: #ddd; /* 灰色分隔线颜色 */
    margin: 0 12px; /* 左右间距，可自行调整 */
  }
}
</style>
